import { ErrorMessage } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { config } from '~/config';

import * as S from './DocumentError.styles';

export const DocumentError = () => {
  const { t } = useTranslation(['intel']);

  return (
    <S.ErrorStateRoot data-testid="error-state">
      <ErrorMessage
        displayIcon="error"
        title={t('intel:documentSearchError.title')}
        subtitle={
          <S.ErrorSubtitle>
            {t('intel:documentSearchError.subtitle')}
            <S.EmailLink href={`mailto:${config.supportEmail}`}>
              {config.supportEmail}
            </S.EmailLink>
          </S.ErrorSubtitle>
        }
      />
    </S.ErrorStateRoot>
  );
};
